import { useEffect, useState } from "react";
import styles from "./RecentlySearched.module.scss";
import CustomLink from "@Components/CustomLink";
import Chevron from "@Icons/Chevron";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
import useWhitelabel from "hooks/useWhitelabel";
import { convertToWhitelabelURL } from "@Pages/WhitelabelHome/Desktop/helpers/WhiteLabelRedirectionHelper";
//

const RecentlySearched = () => {
  const [recentlyVisited, setRecentlyVisited] = useState<any[]>([]);
  const { t } = useTranslationHook();
  const { getFilteredRecentlyVisited, partner_uuid, isDemoSubdomain } = useWhitelabel();
  const recentSearchesText = t("home.recentlysearched");

  useEffect(() => {
    try {
      const filteredResult = getFilteredRecentlyVisited();
      setRecentlyVisited(filteredResult);
    } catch (error) {
      setRecentlyVisited([]);
    }
  }, []);

  // const translatedPlaces = recentlyVisited.map((place:any) => ({
  //   ...place,
  //   translatedName: t(place.name),
  // }));

  return (
    <div className={styles.recentlyVisitedContainerInner}>
      {recentlyVisited.length ? (
        <div className={styles.textContainer} data-testid="homepage-recent-searches-section">
          <div className={styles.staticText}>{recentSearchesText}:</div>
          <div className={styles.horizontalScroll}>
            {recentlyVisited
              .filter(
                (place: any) =>
                  place.name &&
                  place.canonical_name &&
                  place.name.trim() &&
                  place.canonical_name.trim(),
              )
              .map((place: any) => (
                <CustomLink
                  to={convertToWhitelabelURL(
                    `/places/search/${place.canonical_name}`,
                    isDemoSubdomain,
                    partner_uuid,
                  )}
                  className={styles.recentlySearchedPill}
                  redirect={false}
                >
                  <div className={styles.ellipsisText} data-testid={place.name}>
                    {place.name}
                  </div>
                  <Chevron rotate="-90" height="12" width="12" />
                </CustomLink>
              ))}
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default wrapperHOC(RecentlySearched, {
  componentName: "RecentlySearched-HeroSectionDesktop-Home",
  showForChina: true,
});
